var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(this.getLoadStatus)?_c('div',{staticClass:"app__loader"},[_c('div',{staticClass:"loader"},[_c('div'),_c('div'),_c('div'),_c('div')])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }